import { Outlet, createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/devices/_form')({
  component: RouteComponent
});
function RouteComponent() {
  return <Outlet />;
}